export default __webpack_public_path__ + "static/media/Amazon-25.9c2f7646.svg";